import React from 'react'
import AuthLayout from './AuthLayout'
import { Button } from '@/components/ui/button'
import FormField from '@/components/common/FormField'
import { Loader2 } from 'lucide-react'
import { RoutesLink } from '@/utility/RouteLinks'
import { useNavigate } from 'react-router-dom'
import { useForm, type SubmitHandler } from 'react-hook-form'
import { useState } from 'react'
import { ArrowLeft } from 'lucide-react'
import { errorTypes } from '@/utility/validation'
import { callApi, ThrowError } from '@/api/callApi'
import { API_ENDPOINT, } from '@/api/constant'
import { showToastNotification } from '@/utility/helper'
import { v4 as uuidv4 } from 'uuid';

interface IForgotForm {
    email: string;
    deviceid: string;
    device: {
        otp: string;
    };
    message: string;
}
interface IForgotResponse {
    status?: boolean;
    statusCode?: number;
    message?: string;
    data?: {
        email?: string;
        deviceid?: string;
        device?: {
            otp?: string;
        };
    };
}

const Forgot: React.FC = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<IForgotForm>();
    const randomDeviceId = uuidv4();
    const onSubmit: SubmitHandler<IForgotForm> = async (data) => {
        let deviceId = ""
        if (localStorage.getItem(import.meta.env.VITE_BUSINESS + 'deviceId')) {
            deviceId = localStorage.getItem(import.meta.env.VITE_BUSINESS + 'deviceId') ?? '';
        } else {
            deviceId = '2025_' + randomDeviceId;
        }
        localStorage.setItem(import.meta.env.VITE_BUSINESS + 'deviceId', deviceId)
        const payload = {
            email: data?.email,
            deviceId: deviceId,
        };
        console.log(deviceId);

        try {
            setIsLoading(true);
            const response = await callApi<IForgotResponse>(`${API_ENDPOINT.auth}/forget-password`, {
                method: "POST",
                data: payload,
            });

            console.log('response', response)
            showToastNotification("success", response?.message || "OTP Sent Successfully");
            navigate(RoutesLink?.authRoutes?.verifyOtp, { state: { email: data?.email, otp: response?.data?.device?.otp, deviceId: deviceId } });
        } catch (error) {
            showToastNotification("danger", "Failed to send OTP");
            ThrowError(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <AuthLayout>
            <div className="mb-10 text-center lg:text-left">
                <h2 className="text-3xl font-bold text-slate-900 mb-2">Forgot Password</h2>
                <p className="text-slate-500 font-medium">No worries! Enter your registered email and we'll send you an OTP to reset your password.</p>
            </div>
            <div className="mt-8 space-y-6">
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
                    <FormField
                        type="email"
                        placeholder="Enter your email"
                        label="Email Address"
                        {...register('email', {
                            ...errorTypes.required('Email'),
                            ...errorTypes.email
                        })}
                        error={errors.email?.message}
                    />

                    <Button
                        className="w-full"
                        type="submit"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <Loader2 className="h-5 w-5 animate-spin" />
                        ) : (
                            "Send OTP"
                        )}
                    </Button>
                </form>

                <div className="flex justify-center mt-6">
                    <button
                        onClick={() => navigate(RoutesLink?.authRoutes?.login)}
                        className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-wiser-ink transition-colors cursor-pointer group"
                    >
                        <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
                        Back to Sign In
                    </button>
                </div>
            </div>
        </AuthLayout>
    )
}

export default Forgot